export default class TemplateLogin {
  constructor() {
    document.body.addEventListener('click', event => this.closeModal(event));
    document.querySelector('.admin-login-modal').addEventListener('click', () => this.openModal());
    this.modalWrapper = document.querySelector('.password-page-modal-wrapper');
    this.modalContent = this.modalWrapper.querySelector('.password-page-modal');

    if (this.modalWrapper.querySelector('[data-open-modal]')) {
      this.openModal();
    }

    window.addEventListener('resize', () => this.positionModal());
  }

  closeModal(e) {
    if (e.target.classList.contains('visible')) {
      this.modalWrapper.classList.remove('visible');
      this.modalWrapper.addEventListener('transitionend', () => {
        document.body.classList.remove('scroll-locked');
      });
    }
  }

  openModal() {
    document.body.classList.add('scroll-locked');
    this.positionModal();
    this.modalWrapper.classList.add('visible');
  }

  positionModal() {
    const { width, height } = this.modalContent.getBoundingClientRect();
    this.modalContent.style.marginTop = -(height / 2);
    this.modalContent.style.marginLeft = -(width / 2);
  }
}
